var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { memo } from 'react';
import { TableBodyCell, TableCellText } from '@pocketlaw/tetris';
import { getSearchEntityTypeText } from 'app/domains/global-search/utils/getSearchEntityTypeText';
function TypeCellComponent(props) {
    const { entityType } = props, rest = __rest(props, ["entityType"]);
    const typeText = getSearchEntityTypeText(entityType);
    return (<TableBodyCell {...rest}>
      <TableCellText primary={typeText}/>
    </TableBodyCell>);
}
export const TypeCell = memo(TypeCellComponent);
